// TODO: Fix this the next time the file is edited
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function JSRemoteExecutionView({}: any) {
  return null;
}
